/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Password_PlaceholderInputs */

const en_auth_password_placeholder = /** @type {(inputs: Auth_Password_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Password`)
};

const es_auth_password_placeholder = /** @type {(inputs: Auth_Password_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contraseña`)
};

const fr_auth_password_placeholder = /** @type {(inputs: Auth_Password_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mot de passe`)
};

const de_auth_password_placeholder = /** @type {(inputs: Auth_Password_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passwort`)
};

const ja_auth_password_placeholder = /** @type {(inputs: Auth_Password_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスワード`)
};

const zh_auth_password_placeholder = /** @type {(inputs: Auth_Password_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`密码`)
};

const ar_auth_password_placeholder = /** @type {(inputs: Auth_Password_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كلمة المرور`)
};

const id_auth_password_placeholder = /** @type {(inputs: Auth_Password_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kata sandi`)
};

const it_auth_password_placeholder = /** @type {(inputs: Auth_Password_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Password`)
};

const ru_auth_password_placeholder = /** @type {(inputs: Auth_Password_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пароль`)
};

const pt_auth_password_placeholder = /** @type {(inputs: Auth_Password_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senha`)
};

const ko_auth_password_placeholder = /** @type {(inputs: Auth_Password_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`비밀번호`)
};

/**
* | output |
* | --- |
* | "Password" |
*
* @param {Auth_Password_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const auth_password_placeholder = /** @type {((inputs?: Auth_Password_PlaceholderInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Password_PlaceholderInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_password_placeholder(inputs)
	if (locale === "es") return es_auth_password_placeholder(inputs)
	if (locale === "fr") return fr_auth_password_placeholder(inputs)
	if (locale === "de") return de_auth_password_placeholder(inputs)
	if (locale === "ja") return ja_auth_password_placeholder(inputs)
	if (locale === "zh") return zh_auth_password_placeholder(inputs)
	if (locale === "ar") return ar_auth_password_placeholder(inputs)
	if (locale === "id") return id_auth_password_placeholder(inputs)
	if (locale === "it") return it_auth_password_placeholder(inputs)
	if (locale === "ru") return ru_auth_password_placeholder(inputs)
	if (locale === "pt") return pt_auth_password_placeholder(inputs)
	return ko_auth_password_placeholder(inputs)
});